import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Welcome to <span className="highlight">Gerund Software Solutions</span>
            </h1>
            <p className="hero-subtitle">
              We build innovative software solutions that transform businesses and enhance user experiences.
            </p>
            <div className="hero-buttons">
              <Link to="/slot-in" className="btn btn-primary">
                Explore Our Products
              </Link>
              <button className="btn btn-secondary">
                Get In Touch
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-graphic">
              <div className="floating-card card-1">🚀</div>
              <div className="floating-card card-2">💡</div>
              <div className="floating-card card-3">⚡</div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="products">
        <div className="container">
          <h2 className="section-title">Our Products</h2>
          <div className="products-grid">
            <div className="product-card">
              <div className="product-icon">📱</div>
              <h3>Slot In App</h3>
              <p>
                Our flagship application designed to streamline scheduling and time management 
                for businesses and individuals.
              </p>
              <Link to="/slot-in" className="btn btn-outline">
                Learn More
              </Link>
            </div>
            <div className="product-card coming-soon">
              <div className="product-icon">🔮</div>
              <h3>More Coming Soon</h3>
              <p>
                We're constantly working on new innovative solutions. 
                Stay tuned for exciting announcements!
              </p>
              <span className="badge">Coming Soon</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 